export function getColorFromStatusLabel(status) {
    if (status === "open" || status === "assigned")
        return "black";
    else if (isInterventionTerminated(status))
        return "green";
    else if (status === "performed")
        return "blue";
    else
        return "black";
}

export function getIconNameFromStatusLabel(status) {
    if (status === "open" || status === "assigned")
        return "paused";
    else if (isInterventionTerminated(status))
        return "check";
    else if (status === "performed")
        return "play_arrow";
    else
        return "paused";
}

export function formatStatus(status) {
    if (status === "open" || status === "assigned")
        return "Planifié";
    else if (status === "performed")
        return "En intervention";
    else if (isInterventionTerminated(status))
        return "Réalisé";

    return status;
}

export function getStateColor(status) {
    if (status === "open" || status === "assigned")
        return "waiting-status-color";
    else if (status === "performed")
        return "in-progress-status-color";
    else if (isInterventionTerminated(status))
        return "ok-status-color";

    return status;
}

export function isInterventionTerminated(state) {
    return state === "job_finished" || state === "done" || state === "report_sent"
        || state === "waiting_for_invoice" || state === "closed" || state === "tech_report_integrated"
        || state === "report_generated" || state === "cna_validation";
}